// extracted by mini-css-extract-plugin
export default {"collapsibleRow":"styles_collapsibleRow__dnMHY","rowHeader":"styles_rowHeader__ggWpe","title":"styles_title__r+5dz","leftMargin":"styles_leftMargin__yq13w"};